import React from "react";
import ServicePackageListComponent from "@components/User/Package/PackageList/ServicePackageList";

export default function ServicePackageList() {
  return <ServicePackageListComponent />;
}
